import { Call, ApiUrl, PageParams, ParseGeneralResponse, buildQueryString, setObjectToFormData } from "./ApiUtils";
import AppConfig from "../config/AppConfig";
import moment from 'moment';
import { isEmpty } from "../common/Common";

export function fetchAccountSummary(data, page = 1, perPage = AppConfig.perPage) {
  const {account_id , customer_order_number, status} = data;
  const url = ApiUrl(`v2/billing/account_customer_order_billings?${Object.keys(data).map(key => `${key}=${data[key]}`).join('&')}&${PageParams(page, perPage)}&operation_code=ACSOB`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      invoices: "account_billings",
      stats: "count",
      pagination: "meta.pagination",
    },
  });
}

export function fetchInvoicesWithFilter(data, searchKeyType, searchKeyValue) {
  const opCode = "operation_code=FCSOB";
  const parameter = Object.keys(data).map((key) => `${key}=${data[key]}`);
  let params = parameter.join("&");
  params = params ? `?${opCode}&${params}` : `?${opCode}`;
  const url = ApiUrl(`v2/billing/filtered_customer_order_billings${params}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { invoices: "bills", pagination: "meta.pagination" , status_counts : "status_counts" },
  });
}

export function fetchIndividualInvoices(data) {
  const opCode = "operation_code=AOIN";
  const parameter = Object.keys(data).map((key) => `${key}=${data[key]}`);
  let params = parameter.join("&");
  params = params ? `?${opCode}&${params}` : `?${opCode}`;
  const url = ApiUrl(`v2/billing/approved_order_invoices${params}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      invoices: "order_invoices",
      reapproved_invoices: "reapproved_invoices",
      reapproved_invoices_count: "reapproved_invoices_count",
      pagination: "meta.pagination",
      stats: "status_counts",
    },
  });
}

export function fetchInvoiceDetails(data) {
  const opCode = "operation_code=BLCONB";
  const parameter = Object.keys(data).map((key) => `${key}=${data[key]}`);
  let params = parameter.join("&");
  params = params ? `?${opCode}&${params}` : `?${opCode}`;
  const url = ApiUrl(`v2/billing/consolidate_bill${params}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      invoice: "order_invoices",
      smp_details: "smp_details",
      is_locked: "is_locked",
      is_paid: "is_paid",
      ar_status: "ar_status",
      invoice_logo_address: "invoice_logo_address",
      billing_company_details: "billing_company_details",
      vendor_no: "vendor_no",
      customize_transportation_line_name: "customize_transportation_line_name",
      is_emailed: "is_emailed",
      cash_receipt_pictures: "cash_receipt_pictures",
    },
  });
}

export function fetchSummaryDetails(data) {
  let params = "";
  const opCode = "operation_code=SOIN";
  const parameter = Object.keys(data).map((key) => `${key}=${data[key]}`);
  params = parameter.join("&");
  params = params ? `?${opCode}&${params}` : `?${opCode}`;
  const url = ApiUrl(`v2/billing/summery_order_invoices${params}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      details: "",
    },
  });
}

export function fetchBolPdf(customerOrderId) {
  const url = ApiUrl(
    `v2/billing/get_order_bol_pdf?customer_order_id=${customerOrderId}&operation_code=GOBP`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      bol_file: "bol_file",
    },
  });
}

export function postInvoiceToQb(data) {
  data.operation_code = 'PITQB';
  const url = ApiUrl("v2/account_invoices/post_invoice_to_qb");
  return Call(
    "PUT",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { invoices: "" },
    }
  );
}


export function createDriverRateConfiguration(data) {
  const url = ApiUrl("v2/order_driver_pay_configurations/create_segregation_config");
  return Call(
    "POST",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { errors: "errors",message: "message" },
    }
  );
}

export function updateDriverRate(data) {
  const url = ApiUrl("v2/billing/update_driver_charge_value");
  return Call(
    "PUT",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { data: "" },
    }
  );
}


export function validInvoices(data) {
  const url = ApiUrl("v2/account_invoices/validate_invoices");
  return Call(
    "POST",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { invoices: "" },
    }
  );
}
export function deleteInvoice(data) {
  data.operation_code = 'ID';
  const url = ApiUrl(`v2/account_invoices/delete_invoice_from_qb`);
  return Call(
    "DELETE",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { invoices: "" },
    }
  );
}

export function fetchUpdatedInvoiceNo(data) {
  const url = ApiUrl("v2/account_invoices/updating_invoice_number");
  return Call("POST", url, data, ParseGeneralResponse, {
    responseDataKeys: { message: "message" },
  });
}

export function unlockInvoice(data) {
  data.operation_code = 'IUNLOCK';
  const url = ApiUrl("v2/account_invoices/unlock_invoice");
  return Call(
    "POST",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { invoices: "" },
    }
  );
}

export function removeOrderFromInvoice(data) {
  data.operation_code = 'REMOVE_ORDER_FROM_INVOICE';
  const url = ApiUrl("v2/billing/remove_order_from_invoice");
  return Call(
    "POST",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: { errors: "errors",message: "message" },
    }
  );
}

export function exportFile(fromDate, toDate, status, file_type, desktop_type,include_locked_invoices, warehouse_ids = []) {
  const warehouseParam = Array.isArray(warehouse_ids) && warehouse_ids.length > 0
    ? warehouse_ids.join(',')
    : '';

  const warehouseQuery = warehouseParam ? `&warehouse_ids=${warehouseParam}` : '';

  const url = `${AppConfig.baseUrl}/api/v2/billing/invoice_export_files?status=${status}&from_date=${fromDate}&to_date=${toDate}&file_type=${file_type}&desktop_type=${desktop_type}&include_locked_invoices=${include_locked_invoices}${warehouseQuery}`;

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "file",
    },
  });
}

export function sendInvoice({
  organization_id,
  process_date,
  account_ids,
  warehouse_ids,
  send_option,
  email
}) {
  let url = `${AppConfig.baseUrl}/api/v2/account_invoices/process_invoice_mails_per_day?process_date=${process_date}&organization_id=${organization_id}`;
  
  // Convert account_ids array to comma-separated string if present
  if (account_ids && account_ids.length) {
    url += `&account_ids=${account_ids.join(',')}`;
  }
  
  // Convert warehouse_ids array to comma-separated string if present
  if (warehouse_ids && warehouse_ids.length) {
    url += `&wh_ids=${warehouse_ids.join(',')}`;
  }

  if (send_option === "contactGroups") {
    url += `&send_option=contactGroups`;
  }

  if (send_option === "customEmail") {
    url += `&send_option=customEmail&custom_emails=${email}`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "file",
    },
  });
}


export function exportInvoiceAsExcel(url) {
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      data: "",
    },
  });
}

export function exportInvoiceAsPdf(url) {
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      data: "",
    },
  });
}

export function saveRemark(data) {
  const url = ApiUrl("v2/billing/save_vendor_number");
  return Call("POST", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      message: "message",
    },
  });
}

export function grossOrderReports(data) {
  const url = ApiUrl("v2/gross_order_reports/process_driver_invoice_mails_per_day");
  return Call("POST", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      data: "data",
    },
  });
}

export function exportBillings(data, searchKeyType, searchKeyValue) {
  if(data.search_type === 'CONTAINS') {
    delete data.customer_order_number;
  }
  if(data.search_type === 'EQUAL') {
    delete data.search_type;
  }
  // Preprocess the data to replace undefined values with defaults
  const processedData = {
    ...data,
    warehouse_ids: data.warehouse_id || '',
    driver_ids: data.driver_ids || [],
    sort_by: data.sort_by || '',
    sort_order: data.sort_order || ''
  };

  // Pass encodeReq as false to prevent double encoding
  let params = buildQueryString(processedData, false);
  if (data.search_type === 'CONTAINS' && !isEmpty(searchKeyType) && !isEmpty(searchKeyValue)) {
    params += `${params ? "&" : ""}search_key=${searchKeyType}&search_value=${encodeURIComponent(searchKeyValue)}`;
  }

  const url = ApiUrl(`v2/billing/billings_export?operation_code=FBLOS${params ? `&${params}` : ''}`);

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { 
      file: "file",
      success: "success",
      message: "message"
    },
  });
}

export function fetchInvoiceConfig(data) {
  const { organization_id } = data;
  const url = ApiUrl(`v2/org_invoice_counter?organization_id=${organization_id}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      configData: "invoice_configuration"
    },
  });
}

export function saveInvoiceConfig(data) {
  const url = ApiUrl("v2/org_invoice_counter/update_org_invoice_counter");
  return Call("POST", url, data, ParseGeneralResponse, {
    responseDataKeys: { msg: "message" },
  });
}

export function sendInvoiceEDIStatus(data) {
  const formData = setObjectToFormData(data);
  const url = ApiUrl(`v2/account_invoices/re_trigger_edi_account_invoices`);
  return Call("POST", url, formData, ParseGeneralResponse, {
    responseDataKeys: {
      msg: "message",
    },
  });
}

export function fetchInvoiceEmailActivity(organizationId, accountInvoiceId) {
  const url = ApiUrl(`v2/account_invoices/invoice_email_activity?organization_id=${organizationId}&account_invoice_id=${accountInvoiceId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      email_activities: "email_activities",
    },
  });
}
